// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UaMM","right":"Footer_right__2QDM8","buttons":"Footer_buttons__1z_JA"};